import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material';

@Component({
  selector: 'icebreadcrumbs',
  templateUrl: './icebreadcrumbs.component.html',
  styleUrls: ['./icebreadcrumbs.component.scss']
})
export class IcebreadcrumbsComponent implements OnInit {

  // Input Members
  @Input() breadcrumb_data: any = {};
  @Output() toolbarMenuItemClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() toolbarMenuItemOpen: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('clickMenuTrigger1') clickMenuTrigger1: MatMenuTrigger;
  @ViewChild('clickMenuTrigger2') clickMenuTrigger2: MatMenuTrigger;
  @ViewChild('clickMenuTrigger3') clickMenuTrigger3: MatMenuTrigger;
  @ViewChild('clickMenuTrigger4') clickMenuTrigger4: MatMenuTrigger;
  @ViewChild('clickMenuTrigger5') clickMenuTrigger5: MatMenuTrigger;

  lastToolbarItemClicked: any = null;

  constructor() { }

  ngOnInit() {
  }

  getCrums(): any[] {
    let bCrums = this.breadcrumb_data;
    let ret: any[] = [];
    if (bCrums.FARM != null && bCrums.FARM.data != null) ret.push(bCrums.FARM);
    if (bCrums.YARD != null && bCrums.YARD.data != null) ret.push(bCrums.YARD);
    if (bCrums.TREE != null && bCrums.TREE.data != null) ret.push(bCrums.TREE);
    if (bCrums.BRANCH != null && bCrums.BRANCH.data != null) ret.push(bCrums.BRANCH);

    ret = ret.concat(bCrums.LEAVES);
    return ret;
  }

  isToolbar(): boolean {
    this.toolbarMenuItemClick.observers.length
    return this.breadcrumb_data.TOOLBARS != null && this.breadcrumb_data.TOOLBARS.length > 0 && this.toolbarMenuItemClick.observers.length != 0;
  }

  isVisible(): boolean {
    return this.breadcrumb_data != null && this.breadcrumb_data.HIDE == null || this.breadcrumb_data.HIDE == false;
  }

  getToolbars(): any[] {
    let bars = this.breadcrumb_data.TOOLBARS;
    return bars == null ? [] : bars;
  }

  getToolbarItems(toolbar: any): any[] {
    return toolbar == null || toolbar.items == null || toolbar.items.length == 0 ? [] : toolbar.items;
  }

  getToolbarItemDisplay(toolbarItem: any): string {
    if (toolbarItem == null || toolbarItem.display == null || toolbarItem.display.length == 0) return "";

    return toolbarItem.display;
  }

  getToolbarItemMenu(toolbarItem: any): string {
    if (toolbarItem == null || toolbarItem.menuitem == null || toolbarItem.menuitem.length == 0) return "appMenu1";

    return toolbarItem.menuitem;
  }

  getToolbarItemMenuItems(toolbar: any, menuitem: string): any[] {
    if (toolbar == null || menuitem == null || toolbar[menuitem] == null
      || toolbar[menuitem].menuItems == null || toolbar[menuitem].menuItems.length == 0) return [];

    return toolbar[menuitem].menuItems;
  }

  getToolbarItemStyle(toolbarItem: any): any {
    let style = {
      color: 'black'
    };

    if (toolbarItem && toolbarItem.properties != null) {
      if (toolbarItem.properties.color != null)
        style.color = toolbarItem.properties.color;
    }
    return style;
  }

  getToolbarItemClass(toolbarItem: any): any {
    if (toolbarItem == null || toolbarItem.properties == null || toolbarItem.properties.class == null)
      return '';

    return toolbarItem.properties.class;
  }


  onToolbarItemClick(event, toolbar: any, item: any) {
    this.lastToolbarItemClicked = item;
    event.toolbar = toolbar;
    event.toolbarItem = this.lastToolbarItemClicked;
    this.toolbarMenuItemOpen.emit(event);
    switch (item.menuitem) {
      case "appMenu1": {
        this.clickMenuTrigger1.openMenu();
        break;
      }
      case "appMenu2": {
        this.clickMenuTrigger2.openMenu();
        break;
      }
      case "appMenu3": {
        this.clickMenuTrigger3.openMenu();
        break;
      }
      case "appMenu4": {
        this.clickMenuTrigger4.openMenu();
        break;
      }
      case "appMenu5": {
        this.clickMenuTrigger5.openMenu();
        break;
      }
    }
  }

  onToolbarMenuClick(event, toolbar: any, toolbarMenuItem: any) {
    event.toolbar = toolbar;
    event.toolbarItem = this.lastToolbarItemClicked;
    event.toolbarMenuItem = toolbarMenuItem;
    this.toolbarMenuItemClick.emit(event);
    this.lastToolbarItemClicked = null;
  }
}
